// @flow
import React from 'react';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import styles from './SideNewsButton.styles';
import sidebarToggle from 'app/redux/actions/sidebarToggle';

class SideNewsButton extends React.Component<Props> {

    openSidebar = () => {
      const newState = this.props.sidebarIsOpen ? 'close' : 'open';
      this.props.dispatch(sidebarToggle(newState));
    }

    render() {
      const {classes} = this.props;    
      return (
        <div className={classes.latestNewsButton} onClick={this.openSidebar}>
          <br />مطالب <br /> جدید
          <span className={classes.arrowDown} />
        </div>
      );
    }
}

const mapStateToProps = state => ({
  sidebarIsOpen: state.sidebarToggle === 'open',
});

const Component = connect(mapStateToProps)(withStyles(styles)(SideNewsButton));
export {Component as SideNewsButton};
export default Component;